// extracted by mini-css-extract-plugin
export default {"benefitImage":"YArPU7"};